export default "__VITE_ASSET__Cif1aIiw__"